import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const COOKIE_KEY = 'chichi_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-[9999] px-4 pb-4"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-[#2C2C2C] text-white rounded-xl shadow-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={handleDecline}
              className="absolute top-6 right-6 sm:hidden text-white/50 hover:text-white transition-colors"
              aria-label="Chiudi"
            >
              <X size={18} />
            </button>

            <div className="flex-1 text-sm leading-relaxed text-white/80">
              Usiamo cookie tecnici per migliorare la tua esperienza. Nessun tracciamento senza il tuo consenso.{' '}
              <Link
                to="/privacy-policy"
                className="underline text-white hover:text-[#C4A57B] transition-colors"
              >
                Privacy Policy
              </Link>
            </div>

            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={handleDecline}
                className="text-sm text-white/60 hover:text-white transition-colors underline"
                data-testid="cookie-decline-btn"
              >
                Rifiuta
              </button>
              <button
                onClick={handleAccept}
                className="bg-[#A67C52] hover:bg-[#8B6440] text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors"
                data-testid="cookie-accept-btn"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
